export default "__VITE_ASSET__CJtH1PbQ__"